<base-dialog title="{{ title }}">
   <div class="disable-container">
      <p class="text" [innerHTML]="message"></p>
      <button class="button" (click)="dialogRef.close(true)">{{ buttonTitle }}</button>
   </div>
</base-dialog>
